import { render, staticRenderFns } from "./sunDrive.vue?vue&type=template&id=610c52d4&scoped=true"
import script from "./sunDrive.vue?vue&type=script&lang=js"
export * from "./sunDrive.vue?vue&type=script&lang=js"
import style0 from "./sunDrive.vue?vue&type=style&index=0&id=610c52d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610c52d4",
  null
  
)

export default component.exports